<template>
    <div id="about">
        <PageHeader />
        <div class="container">
            <div class="brief-description">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="left-side">
                            <h1>Our aim is to help you save time and money</h1>
                            <h4>
                                <strong>Without the need to employ</strong> your
                                own IT team.
                            </h4>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="right-side">
                            <p>
                                Infinito Group was founded in 2019 as MDAP
                                Holdings and since then we’ve been building
                                relationships with clients, helping them save
                                time and money without the need to employ their
                                own IT team. We now offer IT solutions to any
                                industory, e.g. accounting, engineering,
                                education and many other industories.
                            </p>

                            <router-link to="/contact-us"
                                >Connect with us
                                <i class="fas fa-arrow-circle-right"></i
                            ></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vision-mission">
            <div class="container">
                <div class="vision">
                    <div class="row">
                        <div class="col-sm-6">
                            <img src="../assets/img/vision.jpg" alt="" />
                        </div>
                        <div class="col-sm-6">
                            <h1>Our vision</h1>
                            <h4>
                                To create a reliable and sustainable ICT for the
                                Eastern Cape before moving to the rest of the
                                country.
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="mission">
                    <div class="row">
                        <div class="col-sm-6">
                            <h1>The mission we are on</h1>
                            <h4>
                                We delve to create value while we commit a
                                permanent solution to your ICT problem.
                            </h4>
                        </div>
                        <div class="col-sm-6">
                            <img src="../assets/img/mission.jpg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="h-divider mx-auto" />
        <div class="full-about">
            <div class="container">
                <h1 class="text-center">Let us help you!</h1>
                <p>
                    <strong>
                        Infinito Group was founded in 2019 by Ayanda Peyana
                        (Bcompt) and Mkhosi Dlamini (NDip Electrical Eng.) with
                        it's initail focus and working with the municipalities
                        to assist in bigger ICT related projects. Shortly after
                        6 months we decided to broaden our customer base to also
                        focus on businesses that need ICT services.
                    </strong>
                </p>

                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Debitis necessitatibus officia error cum nihil voluptas
                    dolorem obcaecati vero magnam exercitationem.
                </p>

                <p>
                    Itaque quos, error non quam quibusdam nemo nam, pariatur
                    distinctio officiis placeat magni necessitatibus facere.
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Aliquam velit, fugit sint impedit recusandae animi.
                </p>

                <p>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                    Maxime quis, vero blanditiis ullam qui voluptatem iure hic
                    veritatis dolorem ipsam? Officia veritatis perspiciatis
                    eveniet iure consequuntur obcaecati voluptatum excepturi
                    molestiae. Laboriosam accusamus porro blanditiis cumque!
                    Corrupti sapiente, suscipit aliquid eius facere voluptas est
                    magni nesciunt sit illum molestias a cumque sunt fuga rem
                    tempora ullam, dolorum necessitatibus consequuntur,
                    veritatis voluptatibus.
                </p>

                <p>
                    Laboriosam accusamus porro blanditiis cumque! Corrupti
                    sapiente, suscipit aliquid eius facere voluptas est magni
                    nesciunt sit illum molestias a cumque sunt fuga rem tempora
                    ullam, dolorum necessitatibus consequuntur, veritatis
                    voluptatibus.
                </p>
            </div>
        </div>
        <newsletter />
    </div>
</template>

<script>
import PageHeader from "../components/fragments/PageHeader.vue";
import Newsletter from "../components/fragments/Newsletter.vue";
export default {
    components: {
        PageHeader,
        Newsletter,
    },
};
</script>
